import { Board, BoardType } from "@sportactics/board-editing";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useSelectBoardType } from "../select-board-type";
import { useUser } from "../user";
import { useBoardFirestorePersistence } from "./use-board-firestore-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBoardFirestoreSWR() {
  const key = useKey();
  const fetcher = useFetcher();

  return useSWR(key, fetcher, { suspense: true });
}

export function getBoardFirestoreSWRKey(
  userId: string,
  boardType: BoardType,
): BoardFirestoreSWRKey {
  return getSWRKey(SwrStore.FirestoreBoard, userId, boardType);
}

export type BoardFirestoreSWRKey = readonly [SwrStore, string, BoardType];

function useKey(): BoardFirestoreSWRKey | null {
  const { user } = useUser();
  const { boardType } = useSelectBoardType();

  if (boardType === undefined || !user.authenticated) return null;
  return getBoardFirestoreSWRKey(user.id, boardType);
}

function useFetcher(): (key: BoardFirestoreSWRKey) => Promise<Board | null> {
  const { hasBoard, getBoard } = useBoardFirestorePersistence();

  return async ([, userId, boardType]) =>
    (await hasBoard(userId, boardType)) ? getBoard(userId, boardType) : null;
}
